import I18n from "../i18n";
import ROUTE, { RouteKeys, SiderPath } from "./route";
import { MenuType } from "../components/layout/Menu";

const councelingMenu = {
	text: I18n.t("siderTap.counseling"),
	key: RouteKeys.COUNSELING,
	menuType: MenuType.SUB_MENU,
	submenu: [{
		text: I18n.t("siderTap.counseling_overview"),
		key: RouteKeys.COUNSELING_OVERVIEW,
		menuType: MenuType.ITEM,
	},
	{
		text: I18n.t("siderTap.view_coun_by_provider"),
		key: RouteKeys.COUNSELING_BY_PROVIDER,
		menuType: MenuType.ITEM,
	},
	{
		text: I18n.t("siderTap.view_coun_by_platform"),
		key: RouteKeys.COUNSELING_BY_PLATFORM,
		menuType: MenuType.ITEM,
	},
	{
		text: I18n.t("siderTap.view_coun_by_topic"),
		key: RouteKeys.COUNSELING_BY_TOPIC,
		menuType: MenuType.ITEM,
	},
	{
		text: I18n.t("siderTap.view_coun_by_age_range"),
		key: RouteKeys.COUNSELING_BY_AGE,
		menuType: MenuType.ITEM,
	},
	{
		text: I18n.t("siderTap.view_coun_by_gender"),
		key: RouteKeys.COUNSELING_BY_GENDER,
		menuType: MenuType.ITEM,
	},
	{
		text: I18n.t("siderTap.view_coun_by_user_retention"),
		key: RouteKeys.COUNSELING_BY_USER_RETENTION,
		menuType: MenuType.ITEM,
	},
	{
		text: I18n.t("siderTap.view_coun_by_visit_feedback"),
		key: RouteKeys.COUNSELING_BY_FEEDBACK,
		menuType: MenuType.ITEM,
	},
	{
		text: I18n.t("siderTap.view_coun_by_visit_outcome"),
		key: RouteKeys.COUNSELING_BY_VISIT_OUTCOME,
		menuType: MenuType.ITEM,
	}
	]
};
const testMenu = {
	text: I18n.t("siderTap.test"),
	key: RouteKeys.TEST,
	menuType: MenuType.SUB_MENU,
	submenu: [{
		text: I18n.t("siderTap.stress_test"),
		key: RouteKeys.STRESS_TEST,
		menuType: MenuType.SUB_MENU,
		submenu: [
			{
				text: I18n.t("siderTap.usage_overview"),
				key: RouteKeys.STRESS_USAGE_OVERVIEW,
				menuType: MenuType.ITEM,
			},
			{
				text: I18n.t("siderTap.individual_question"),
				key: RouteKeys.STRESS_INDIVIDUAL_QUESTION,
				menuType: MenuType.ITEM,
			}, {
				text: I18n.t("siderTap.view_stress_by_level"),
				key: RouteKeys.STRESS_BY_LEVEL,
				menuType: MenuType.ITEM,
			}, {
				text: I18n.t("siderTap.view_stress_by_age"),
				key: RouteKeys.STRESS_BY_AGE,
				menuType: MenuType.ITEM,
			}
			, {
				text: I18n.t("siderTap.view_stress_by_gender"),
				key: RouteKeys.STRESS_BY_GENDER,
				menuType: MenuType.ITEM,
			}, {
				text: I18n.t("siderTap.view_stress_by_returning"),
				key: RouteKeys.STRESS_BY_RETURNING,
				menuType: MenuType.ITEM,
			}
		]
	}]
};
const peopleMenu = {
	text: I18n.t("siderTap.people"),
	key: RouteKeys.PEOPLE,
	menuType: MenuType.SUB_MENU,
	submenu: [{
		text: I18n.t("siderTap.people_overview"),
		key: RouteKeys.PEOPLE_OVERVIEW,
		menuType: MenuType.ITEM,
	},
	{
		text: I18n.t("siderTap.individual_user"),
		key: RouteKeys.INDIVIDUAL_USER,
		menuType: MenuType.ITEM,
	}
	]
};
const reportMenu = {
	text: I18n.t("siderTap.report"),
	icon: { type: "area-chart" },
	key: RouteKeys.REPORT,
	menuType: MenuType.SUB_MENU,
	submenu: [
		councelingMenu,
		testMenu,
		peopleMenu
	]
};

export default [
	{ text: I18n.t("siderTap.home"), icon: { type: "home" }, key: ROUTE.HOME },
	reportMenu,
	{ text: I18n.t("siderTap.account"), icon: { type: "user" }, key: ROUTE.ACCOUNT },
	{ text: I18n.t("siderTap.setting"), icon: { type: "setting" }, key: ROUTE.SETTING },
	// {
	// 	text:"Playground",
	// 	icon:{ type:"rocket" },
	// 	key:RouteKeys.PLAYGROUND,
	// 	menuType:MenuType.ITEM
	// }
];


// WEBPACK FOOTER //
// ./src/constants/siderRoute.js